class UserData {
  constructor() {
    this.namespaced = true;
    this.state = {
        userData: {
          infoAnchor: '',
          refAnchor: '',
          unitsSystem: 'englishSystem',
          height: '',
          weight: '',
          systolicBp: '',
          diastolicBp: '',
          age: '',
          gender: '',
          bmi: '',
          ldl: '',
          trigs: '',
          hdl: '',
          diab:'',
          sectionFlags: { cancer: false, hyplip: false, hypten: false, infertility: false, nafld: false, osteoarth: false, diab: false, yearsLost: false },
          conditions: { hyplip: false, hypten: false, infertility: false, nafld: false, osteoarth: false, diab: false },
          adjustButtons: { cancer: 0, hyplip: 0, hypten: 0, infertility: 0, nafld: 0, osteoarth: 0, diab: 0, yearsLost: 0 },
          calc: {
            bmi: {
              adj5: '',
              adj10: '',
              adj15: '',
              adj20: '',
            },
            weight: {
              adj5: '',
              adj10: '',
              adj15: '',
              adj20: '',
            },
            cancer: {
              current: '',
              adj5: '',
              adj10: '',
              adj15: '',
              adj20: '',
            },
            
            dyslip: {
              current: '',
              adj5: '',
              adj10: '',
              adj15: '',
              adj20: '',
            },
            hyplip: {
              current: '',
              adj5: '',
              adj10: '',
              adj15: '',
              adj20: '',
            },
            hypten: {
              current: '',
              adj5: '',
              adj10: '',
              adj15: '',
              adj20: '',
            },
            hyptenBP: {
              current: '',
              adj5: '',
              adj10: '',
            },
            pcos: {
              current: '',
              adj5: '',
              adj10: '',
              adj15: '',
              adj20: '',
            },
            pcosRegain: {
              current: '',
              adj5: '',
              adj10: '',
            },
            nafld: {
              current: '',
              adj5: '',
              adj10: '',
            },
            osteoarth: {
              current: '',
              adj5: '',
              adj10: '',
              adj15: '',
              adj20: '',
            },
            oaReduction: {
              current: '',
              adj5: '',
              adj10: '',
              adj15: '',
              adj20: '',
            },
            diab: {
              current: '',
              adj5: '',
              adj10: '',
              adj15: '',
              adj20: '',
            },
            diabA1c: {
              current: '',
              adj5: '',
              adj10: '',
            },
            yearsLost: {
              current: '',
              adj5: '',
              adj10: '',
              adj15: '',
              adj20: '',
            },
          },
          confInt: {
            cancer: {
              current: '',
              adj5: '',
              adj10: '',
              adj15: '',
              adj20: '',
            },
            dyslip: {
              current: '',
              adj5: '',
              adj10: '',
              adj15: '',
              adj20: '',
            },
            hypten: {
              current: '',
              adj5: '',
              adj10: '',
              adj15: '',
              adj20: '',
            },
            pcos: {
              current: '',
              adj5: '',
              adj10: '',
              adj15: '',
              adj20: '',
            },
            nafld: {
              current: '',
              adj5: '',
              adj10: '',
            },
            osteoarth: {
              current: '',
              adj5: '',
              adj10: '',
              adj15: '',
              adj20: '',
            },
            diab: {
              current: '',
              adj5: '',
              adj10: '',
              adj15: '',
              adj20: '',
            },
            yearsLost: {
              current: '',
              adj5: '',
              adj10: '',
              adj15: '',
              adj20: '',
            },
          },

        }
      },
      this.getters = {
        userData: state => {
          return state.userData;
        },
      },
      this.mutations = {
        saveCalculations: (state, { data, section }) => {
          state.userData.calc[section] = data;
        },
        saveConfInt: (state, { data, section }) => {
          state.userData.confInt[section] = data;
        },
        markSectionComplete: (state, { section }) => {
          this.state.userData.sectionFlags[section] = true;
        },
        resetSections: () => {
          this.state.userData.sectionFlags = { cancer: false, hyplip: false, hypten: false, infertility: false, nafld: false, osteoarth: false, diab: false, yearsLost: false };
        },
        resetConditions: (state, { section }) => {
          this.state.userData.conditions[section] = false;
        },
      },

      this.actions = {
        saveCalculations: ({ commit }, { data, section }) => {
          commit('saveCalculations', { data, section });
        },
         saveConfInt: ({ commit }, { data, section }) => {
          commit('saveConfInt', { data, section });
        },
        markSectionComplete: ({ commit }, { section }) => {
          commit('markSectionComplete', { section });
        },
        resetConditions: ({ commit }, { section }) => {
          commit('resetConditions', { section });
        },
        resetSections: ({ commit }) => {
          commit('resetSections');
        },
      };
  }
}

export default UserData;
